import { isEmpty } from './utils';
import { validateMod11CheckSum } from './validateModService';

export const validAccountNumber = (accountNumber: string): boolean => {
    const accountNumberWithoutSpacesAndPeriods = accountNumber.replace(/[\s.]+/g, '');
    if (accountNumberWithoutSpacesAndPeriods.length !== 11) {
        return false;
    }
    return validateMod11CheckSum(accountNumberWithoutSpacesAndPeriods, false);
};

export const sanitizeAccountNumber = (value: string | undefined): string => {
    if (!value || isEmpty(value)) return '';
    return value.replace(/[\s.]+/g, '');
};

export const formatAccountNumber = (accountNumber: { value: string } | undefined, seperator = ' '): string => {
    if (isEmpty(accountNumber?.value) || !accountNumber?.value) return '';
    const withoutLetters = accountNumber.value.replace(/([a-zA-Z])/g, '');
    const onlyNums = accountNumber.value.replace(/[^\d]/g, '');
    if (withoutLetters !== accountNumber.value || onlyNums.length !== 11) {
        return accountNumber.value;
    }
    return [onlyNums.slice(0, 4), onlyNums.slice(4, 6), onlyNums.slice(6, 11)].join(seperator);
};
